<template>
    <div>
        <div class="modal fade" id="mdenviaprodutocoletor" tabindex="-1" role="dialog" aria-labelledby="mdenviaprodutocoletor" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel" style="font-size: 14px;"><i class="fa fa-cubes"></i> Enviar produto p/ o coletor</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <label for="edqtdenviar">*Quantidade:</label>
                                <money type="text" class="form-control form-control-sm" id="edqtdenviar" v-model="qtd" v-bind="money" data-bv-group=".group" style="text-align: right;"></money>
                            </div>                              
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="#" class="btn btn-primary btn-sm" role="button" @click.prevent="mtdconfirmar()"><i class="fa fa-check"></i> Confirmar</a>
                        <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</a>
                    </div>
                </div>
            </div>
        </div>                
    </div>
</template>
<script>
import util from '../utilitarios/util.js'
export default {
    name: 'cmpenviarprodutocoletor',
    props:[
                'produto',
                'qtdenviar'
          ],
    data: function() {
        return {
            qtd                 : 1,
            money				: {
                decimal         : ',',
                thousands       : '.',
                prefix          : '',//aqui colocar o cifrão se for necessário
                precision       : 3,
                masked          : false
            }            
        };
    },
    methods: {
        mtdconfirmar(){
            if (parseFloat(this.qtd) <= 0){
                this.$toastr.w('Quantidade inválida!', 'Atenção!');
                $('#edqtditemedicao').focus();
                return;
            }                
            if (parseInt(this.produto.fracionado) === 0){
                if (!Number.isInteger(this.qtd)){
                    this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
                    $('#edqtdenviar').focus();
                    return;
                }
            }
            $('#mdenviaprodutocoletor').modal('hide');
            let item = {
                'idproduto'             : this.produto.id,
                'qtd'                   : parseFloat(this.qtd)
            };
            util.rotinacoletor(this, item, 1, this.mtdlistaritenscoletor, this.$store.state.usuario.adrsrv);            
        },
        mtdlistaritenscoletor(itens){                
            util.atzitenscoletor(this, itens, true, this.$store.state.usuario.adrsrv);                
            if (itens.length > 0){
                this.$toastr.s('Item enviado para o coletor!', 'Confirmação!');
            }
        }        
    },
    mounted: function() {
        let vself = this;
        $("#mdenviaprodutocoletor").on('shown.bs.modal', function(){
            vself.qtd = vself.qtdenviar;
            $('#edqtdenviar').focus();
        });
    },    
    computed:{ 
    },
    watch: {

    }
}
</script>
<style>
    #mdenviaprodutocoletor{
        z-index: 2001!important;
    }    
</style>